module.exports = __webpack_public_path__ + "static/media/nro-fd.27fc73c2.png";